module.exports = __webpack_public_path__ + "static/media/ICT-14.6d524a0f.png";